/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentScopeEnum } from './DocumentScopeEnum';
import {
    DocumentScopeEnumFromJSON,
    DocumentScopeEnumFromJSONTyped,
    DocumentScopeEnumToJSON,
    DocumentScopeEnumToJSONTyped,
} from './DocumentScopeEnum';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * 
 * @export
 * @interface DocumentViewItem
 */
export interface DocumentViewItem {
    /**
     * 
     * @type {string}
     * @memberof DocumentViewItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentViewItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentViewItem
     */
    subscriberName: string;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof DocumentViewItem
     */
    fileType: FileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentViewItem
     */
    status: string;
    /**
     * 
     * @type {Date}
     * @memberof DocumentViewItem
     */
    uploadDate: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentViewItem
     */
    mimetype: string;
    /**
     * 
     * @type {Date}
     * @memberof DocumentViewItem
     */
    validationDate?: Date;
    /**
     * 
     * @type {DocumentScopeEnum}
     * @memberof DocumentViewItem
     */
    scope: DocumentScopeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentViewItem
     */
    tags: Array<string>;
}



/**
 * Check if a given object implements the DocumentViewItem interface.
 */
export function instanceOfDocumentViewItem(value: object): value is DocumentViewItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('subscriberName' in value) || value['subscriberName'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('uploadDate' in value) || value['uploadDate'] === undefined) return false;
    if (!('mimetype' in value) || value['mimetype'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('tags' in value) || value['tags'] === undefined) return false;
    return true;
}

export function DocumentViewItemFromJSON(json: any): DocumentViewItem {
    return DocumentViewItemFromJSONTyped(json, false);
}

export function DocumentViewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentViewItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'subscriberName': json['subscriberName'],
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'status': json['status'],
        'uploadDate': (new Date(json['uploadDate'])),
        'mimetype': json['mimetype'],
        'validationDate': json['validationDate'] == null ? undefined : (new Date(json['validationDate'])),
        'scope': DocumentScopeEnumFromJSON(json['scope']),
        'tags': json['tags'],
    };
}

export function DocumentViewItemToJSON(json: any): DocumentViewItem {
    return DocumentViewItemToJSONTyped(json, false);
}

export function DocumentViewItemToJSONTyped(value?: DocumentViewItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'subscriberName': value['subscriberName'],
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'status': value['status'],
        'uploadDate': ((value['uploadDate']).toISOString().substring(0,10)),
        'mimetype': value['mimetype'],
        'validationDate': value['validationDate'] == null ? undefined : ((value['validationDate']).toISOString().substring(0,10)),
        'scope': DocumentScopeEnumToJSON(value['scope']),
        'tags': value['tags'],
    };
}

